export class ReportPdcDownloadRequest {
  public healthNetworkPlanCode: string;
  public username: string;
  public searchType: string;
  public providerIds: string[];
  public providerNPIs: string[];
  public documentType: string;
}
